<template>
  <div class="card">
    <div class="card-header">
      <h4 style="padding: 10px">Bot Settings</h4>
    </div>
    <div class="card-body">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-bs-toggle="tab" href="#connected-numbers" role="tab">
            <span class="hidden-sm-up"></span>
            <span class="hidden-xs-down">Connected Numbers</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#bot-settings" role="tab">
            <span class="hidden-sm-up"></span>
            <span class="hidden-xs-down">Bot Settings</span>
          </a>
        </li>
      </ul>
      <div class="tab-content tabcontent-border">
        <div class="tab-pane active" id="connected-numbers" role="tabpanel">
          <ConnectedNumbers  />
        </div>
        <div class="tab-pane" id="bot-settings" role="tabpanel">
          <BotConfig  />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConnectedNumbers from './ConnectedNumbers.vue';
import BotConfig from './BotConfig.vue';

export default {
  name: 'BotSettings',
  components: {
    ConnectedNumbers,
    BotConfig
  }
};
</script>

<style scoped>
.card {
  /* background-color: #2b2e4c;
  border: 1px solid #424351; */
  color: #e9e6e6;
}

.card-header {
  /* background-color: #2b2e4c; */
  border-bottom: 1px solid #424351;
}

.card-body {
  padding: 1.25rem;
}

.nav-tabs {
  border-bottom: 1px solid #424351;
}

.nav-tabs .nav-link {
  color: #e9e6e6;
  border: none;
  padding: 0.5rem 1rem;
}

.nav-tabs .nav-link:hover {
  color: #716fe5;
  border: none;
}

.nav-tabs .nav-link.active {
  color: #f3f6f1;
  background-color: transparent;
  border: none;
  border-bottom: 2px solid #4B49AC;
}

.tab-content {
  background-color: #2b2e4c;
  padding: 20px;
  border-radius: 0 0 4px 4px;
  border: 1px solid #424351;
  border-top: none;
}
</style> 